import { maximalLLMService } from './llm/domain/maximal.llm.service';

/**
 * Legacy export for backward compatibility.
 * This now delegates to the Maximal Domain LLM Service.
 */
export const llmService = maximalLLMService;
